export default __webpack_public_path__ + "static/media/licee.b39ca85b.svg";